import checkStatus from '../../../utils/checkStatus.js';
import s3 from '../../../utils/s3ContractingFilesUpload';
import editProductInfo from '../contract-activities-products/edit-product';
import editContractDetails from '../contract-activities-products/edit-contract-details';
import { getContractLeftNav, reloadContentInBg } from '../contract-activities-products/contract-activities-products-actions';
import { put } from '../../../utils/http';
import { callApiJWT } from '../../../api';
import R, { ifElse, prop, call, compose, contains, propOr, merge } from 'ramda';

export const openOrCloseDialogsActions = {
  freeContractDialog: 'CLOSE_FREE_CONTRACT_DIALOG',
};

export const addEditContractDialogActions = {
  openAddEditContractDialog: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
  closeAddEditContractDialog: 'CLOSE_ADD_EDIT_CONTRACT_DIALOG',
  removeInsFile: 'REMOVE_INSURANCE_FILE',
};

export const publishDraftDialogActions = {
  closePublishDraftDialog: 'CLOSE_PUBLISH_DRAFT_DIALOG',
  onTextFieldChangePublishDraftDialog: 'ON_TEXTFIELD_CHANGE_PUBLISH_DRAFT_DIALOG',
  notEnoughFreeContracts: 'NOT_ENOUGH_FREE_CONTRACTS',
  onBCCSelfCheck: 'ON_BCC_SELF_CHECK',
  includeNotesCheck: 'INCLUDE_NOTES_CHECK',
  includeMultiLocNotesCheck: 'INCLUDE_MULTI_LOC_NOTES_CHECK',
  includeGeneralNoteCheck: 'INCLUDE_GENERAL_NOTE_CHECK',
};

export const resendContractActions = {
  closeResendContractDialog: 'CLOSE_RESEND_CONTRACT_DIALOG',
  onBCCSelfCheck: 'ON_BCC_SELF_CHECK',
};
export const updatePropsInResendContractReducer = payload => ({
  type: 'UPDATE_PROPS_RESEND_CONTRACT_REDUCER',
  payload,
});

export const deleteInsFile = payload => (dispatch, getState) => {
  const draftId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']);
  return fetch('/proxy/contracting/deleteInsFile', {
    method: 'delete',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(R.merge(payload, { draftId })),
  })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: 'REMOVE_INSURANCE_FILE', payload });
    });
};

export const updateBuyerInfo = payload => {
  return dispatch => {
    const url = '/proxy/contracting/contract/buyer';
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    return put(url, payload)
      .then(checkStatus)
      .then(res => res.json())
      .then(({ contractId }) => {
        if (contractId === payload.contractId) dispatch({ type: 'UPDATE_BUYER_INFO', payload });
        else window.location = `${window.location.protocol}//${window.location.host}/contracting/contract/${contractId}/details`;
      })
      .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Update Failed.' }));
  };
};

export const saveBillingInfoChanges = payload => (dispatch, getState) => {
  const insuranceFiles = R.pathOr([], ['data', 'insuranceFiles'], payload);
  payload.data.insuranceFiles = R.pathOr([], ['data', 'insuranceFiles'], payload)
    .map(({ downloadUrl, fileName, _id, name, type }) => ({ downloadUrl, fileName, _id, name, type }));
  payload.sameAsCorporatePolicyNotes = (getState().contracting.contractActivitiesProducts
    .get('rightSideContent').toJS()
    .sameAsCorporatePolicyNotes || [])
    .filter(str => str !== payload.type);
  dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
  return put('/proxy/contracting/contract/billing', payload)
  .then(checkStatus)
  .then(res => res.json())
  .then(({ files, errors }) => {
    const fileMap = insuranceFiles.length ? insuranceFiles.reduce((map, file) => ({ ...map, [file.name || file.fileName]: file }), {}) : [];
    Promise.all(
      (files.length ? files.filter(R.prop('signedUrl')).map(({ fileName, signedUrl, downloadUrl }) =>
        s3.uploadToS3(fileMap[fileName], signedUrl, downloadUrl, fileName)
      ) : []));
    return dispatch({ type: 'SAVE_BILLING_INFO_ADD_EDIT', payload: R.merge(payload, { errors }) });
  });
};


import { checkLocAccess, triggerNoAccessWarning } from '../../../middleware/accessCheckHelperFns';
import { replace } from 'react-router-redux';
import { processEditHistories } from '../../../components/contracting/contractingUtils';
export const publishDraft = (payload) => (dispatch, getState) => {
  const { goToSend } = payload;
  const {
    contractId,
    locationId,
    draftType,
    originFrom,
    editHistory,
    productsArray,
    startDate,
    endDate,
    diffSummary,
    createdAt,
  } = getState().contracting.contractActivitiesProducts.get('leftNav').toJS();
  const { sendUpdatesSubject, doNotIssueUpdate, sendUpdatesMessage } = getState().contracting.publishDraftDialog.toJS();

  const readOnly = !checkLocAccess(getState(), locationId, 'contracting', 'write');
  if (readOnly) return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));

  dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { publishingDraft: true } });

  return put(`/proxy/contracting/draft/publish/${contractId}`, {
    draftType,
    message: sendUpdatesMessage,
    originFrom,
    subject: sendUpdatesSubject,
    editHistory: processEditHistories(editHistory, productsArray),
    startDate,
    endDate,
    doNotIssueUpdate,
    diffSummary,
  })
  .then(res => {
    if (res.status !== 200) throw new Error(res.status);
    dispatch({
      type: 'PUBLISH_TEMPLATE_DRAFT_SUCCESS',
      payload: {
        originFrom,
      },
    });
    return res.json();
  })
  .then((publishedContract) => {
    if (publishedContract && publishedContract.id) {
      if (goToSend) {
        dispatch(replace(`/contracting/template/${publishedContract.id}/partners`));
      } else dispatch(replace(`/contracting/${draftType === 'template' || originFrom !== 'edited' ? 'template' : 'contract'}/${publishedContract.id}/details`));
    }
  })
  .catch((err) => {
    console.log(err.stack);
    dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { publishingDraft: false } });
    dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Publish Draft Failed' });
  });
};

export const saveSupplierInfoChanges = (payload) => {
  return (dispatch, getState) => {
    const initialContractDetails = getState().contracting.contractActivitiesProducts.get('rightSideContent');
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    const newContractDetailsAndEditHistory = editContractDetails(initialContractDetails, payload);
    const newPayload = {
      contractId: payload.contractId,
      collection: window.location.pathname.indexOf('/workspace/') > -1 ? 'workspace' : 'draft',
      contractDetails: newContractDetailsAndEditHistory.contractDetails.toJS(),
      editHistory: newContractDetailsAndEditHistory.editHistory,
    };
    return put('/proxy/contracting/contract/supplier', newPayload)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      dispatch({ type: 'CONTRACT_SUPPLIER_DETAIL_UPDATED', payload: R.merge(newPayload, { errors: res.errors }) });
    })
    .catch((err) => {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving changes failed' });
    });
  };
};

export const manageRatePackage = (contractId, productId, data) => {
  return (dispatch, getState) => {
    dispatch({ type: '[contract-product]CREATE_RATE_PACKAGE_START' });
    return callApiJWT(`/contracting/contract/product/ratepackage`, 'post', { ...data, contractId, productId })
    .then(({ response: res }) => {
      dispatch(getContractLeftNav('draft', contractId));
      /*
      res = { errors: errorChecking(newDraft), contractId, newRatePackage }
       */
      return dispatch({
        type: '[contract-product]CREATE_RATE_PACKAGE_SUCCESS',
        payload: res,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'create rate package failed' });
    });
  };
};

export const saveProductsToContract = (contractId, locationId, products) => {
  return (dispatch, getState) => {
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    const composedUrl = `/proxy/contracting/saveProductsToContract`;
    return put(composedUrl, {
      contractId,
      locationId,
      products,
    })
    .then(checkStatus)
    .then(res => res.json())
    .then((res) => {
      dispatch(getContractLeftNav('draft', contractId));
      return dispatch({ type: 'PRODUCTS_SAVED_UPDATE_REDUX', payload: { contractId, errors: res.errors, firstProduct: R.pathOr({}, ['products', 0], res) } });
    })
    .catch(err => console.log(err));
  };
};

export const syncProductInfo = payload => (dispatch, getState) => {
  dispatch({
    type: 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT',
    payload: {
      sectionInEdit: payload.sectionInEdit,
      checked: typeof payload.syncSection === 'boolean' ? payload.syncSection : true,
    },
  });
  const newPayload = {
    contractId: payload.contractId,
    productId: payload.productId,
    syncSection: typeof payload.syncSection === 'boolean' ? payload.syncSection : true,
    syncRatesToo: payload.syncRatesToo,
    sectionInEdit: payload.sectionInEdit,
    product: getState().contracting.contractActivitiesProducts.get('rightSideContent'),
  };
  return callApiJWT('/contracting/contract/product', 'put', newPayload)
  .catch((err) => {
    console.log(err.stack);
    return dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Syncing product failed' });
  });
};

export const saveProductInfoChanges = (payload) => (dispatch, getState) => {
  const syncedSectionsImmutable = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'syncedSections']);
  const initialProduct = getState().contracting.contractActivitiesProducts.get('rightSideContent');
  dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
  const newProductAndEditHistory = editProductInfo(initialProduct, payload);
  const sectionInEdit = newProductAndEditHistory.section;
  const syncSection = syncedSectionsImmutable ? R.contains(sectionInEdit, syncedSectionsImmutable.toJS()) : false;
  const newPayload = {
    contractId: payload.contractId,
    productId: payload.productId,
    syncSection,
    sectionInEdit,
    hash: newProductAndEditHistory.hash,
    product: newProductAndEditHistory.product.toJS(),
    editHistory: {
      ...newProductAndEditHistory.editHistory,
      productId: payload.productId,
      contractId: payload.contractId,
      ratePackageName: initialProduct.get('ratePackageName'),
    },
  };
  return callApiJWT('/contracting/contract/product', 'put', newPayload)
    .then(({ response: res }) => {
      dispatch({ type: 'CONTRACT_PRODUCT_UPDATED', payload: merge(newPayload, { product: res.product, errors: res.errors }) });
    })
    .catch((err) => {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving product changes failed' });
    });
};

const savedOrHandleDuplicates = dispatch => ifElse(
  prop('duplicateExists'),
  () => dispatch({ type: 'SAVING_NEW_TEMPLATE_FAILED_BECAUSE_DUPLICATES' }),
  payload => dispatch({ type: 'SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED', payload })
);

export const saveAsANewTemplate = payload => {
  return dispatch => {
    dispatch({ type: 'SAVING_TEMPLATE_AFTER_DRAFT_PUBLISHED' });
    return put('/proxy/contracting/saveAsANewTemplate', payload)
    .then(checkStatus)
    .then(res => res.json())
      .then(savedOrHandleDuplicates(dispatch))
      .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Saving new template failed' }));
  };
};

export const copyDataFromAnotherProduct = payload => {
  return (dispatch, getState) => {
    dispatch({ type: 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG' });
    const { productId, ratePackageName: ratePackage } = getState().contracting.contractActivitiesProducts.toJS().rightSideContent;
    return put('/proxy/contracting/copyContractDataFromAnotherProduct', payload)
      .then(checkStatus)
      .then(res => res.json())
      .then((response) => {
        dispatch({ type: 'DATA_FROM_ANOTHER_PRODUCT_IS_COPIED', payload: response });
        dispatch(reloadContentInBg({
          collection: 'draft',
          contractId: payload.contractId,
          productId,
          ratePackage: ratePackage || 'Primary',
        }));
      })
      .catch(err => {
        const selectedSeasonRates = call(compose(
          contains('seasonRates'),
          propOr([], 'dataFieldsToImport')
        ), payload);
        const seasonError = err.message === 'Bad Request' && selectedSeasonRates;
        return dispatch({
          type: 'COPY_DATA_FROM_ANOTHER_PRODUCT_IN_CONTRACT_IS_FAILED',
          payload: {
            error: seasonError ?
              'Please make sure this product has the same number of seasons as the product you intended to copy from.' :
              'An error occurred. Please try again or contact our customer support.' },
        });
      });
  };
};

export function importContractFromTemplate(payload) {
  return dispatch => {
    return put('/proxy/contracting/importContractFromTemplate', payload)
    .then(() => dispatch({ type: 'IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS' }))
    .catch(() => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Import data failed.' }));
  };
}
export default {
  ...addEditContractDialogActions,
  ...openOrCloseDialogsActions,
  ...publishDraftDialogActions,
  ...resendContractActions,
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-constants.js